import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/videoData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50 shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 h-16 max-w-[1440px] mx-auto" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-2xl font-bold text-primary-500">91</span>
          <span className="text-lg font-semibold text-foreground-950 hidden sm:block">国产视频</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === "/" ? "text-primary-500 bg-primary-50" : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.includes(cat.slug)
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === "/about" ? "text-primary-500 bg-primary-50" : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3 flex flex-col gap-1">
          <Link
            to="/"
            className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${
              location.pathname === "/" ? "text-primary-500 bg-primary-50" : "text-foreground-700"
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                location.pathname.includes(cat.slug) ? "text-primary-500 bg-primary-50" : "text-foreground-700"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${
              location.pathname === "/about" ? "text-primary-500 bg-primary-50" : "text-foreground-700"
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}